<script setup>
import { computed } from "vue";
import free from "@data/free.json";

const currentFree = computed(() => free.filter((item) => item.current));
</script>

<template>
  <section v-if="currentFree.length > 0">
    <h2 class="text-center text-5xl pb-4 uppercase font-bold">
      Free Pick{{ currentFree.length > 1 ? "s" : "" }}
    </h2>
    <ul class="flex flex-col items-center md:text-3xl space-y-4 pb-4">
      <li
        class="flex flex-col justify-center items-center"
        v-for="(fr, idx) in currentFree"
        :key="idx"
      >
        <div>
          <span class=""> {{ fr.date }} {{ fr.time }}&nbsp;</span>
        </div>
        <div>
          <span
            >{{ fr.home }} vs. {{ fr.away }} : {{ fr.pick }} ({{
              fr.odd
            }})</span
          >
        </div>
      </li>
    </ul>
  </section>
</template>
